import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'libs.react';
import { useLumosTrainingProgress } from '../use_lumos_training/use_lumos_training_progress.hook';
export const useLumosTrainingNavigation = () => {
    const { entity } = useContext(AuthContext);
    const navigate = useNavigate();
    const siteTrainingIsRequired = entity?.configuration.siteTrainingRequired;
    const { allModulesCompleted } = useLumosTrainingProgress();
    useEffect(() => {
        if (siteTrainingIsRequired && !allModulesCompleted) {
            navigate('/site/training');
        }
    }, [navigate, siteTrainingIsRequired, allModulesCompleted]);
};
